module.exports = __webpack_public_path__ + "static/bed-bebb79e88c58aa6d8773553af1f7ca18.jpg";